<template>
  <div class="loadingwraper" :class="{loadingwraper_inline: type === 'inline'}">
    <div class="loading-icon icon-loading g_loading"></div>
    <p class="loading-text">{{msg}}</p>
  </div>
</template>

<script>
export default {
  props: {
    msg: String,
    type: String,
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/animation.scss';

.loadingwraper{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 250px;
  height: 50px;
  padding-top: 28px;
  margin: auto;
  text-align: center;
  color: #D8D8D8;
  z-index: 100;
}
.loading-icon{
  font-size: 36px;
  margin-bottom: 4px;
  &:before{
    animation: spin 1s infinite linear;
  }
}
.loading-text{
  font-size: 14px;
  line-height: 20px;
}
.loadingwraper_inline{
  position: static;
  display: inline-block;
  padding: 0;
  height: auto;
  z-index: 1;
  margin: unset;
  width: auto;
}
</style>
